import React, { useState } from 'react';

import { Grid } from '@material-ui/core';

import PageTitle from '../../components/PageTitle/PageTitle';
import PendingTitles from './components/PendingTitles/PendingTitles';
import { WeeklyTitlesGoal } from './components/WeeklyTitlesGoal/WeeklyTitlesGoal';
import Layout from '../../components/Layout/Layout';

const Dashboard: React.FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const [updatePendingTitles, setUpdatePendingTitles] = useState<any>(() => {});

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={4}>
          <PageTitle title="Dashboard" />
        </Grid>
        <PendingTitles setUpdatePendingTitles={setUpdatePendingTitles} />
        <WeeklyTitlesGoal updatePendingTitles={updatePendingTitles} />
      </Grid>
    </Layout>
  );
};

export default Dashboard;
